import { Heading } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

const SuppliersView = () => {
  return (
    <>
      <Heading as={"h2"} p={3}>
        E-commerce - Suppliers
      </Heading>

      <Outlet />
    </>
  );
};

export default SuppliersView;
